module.exports = __webpack_public_path__ + "img/cabinet_disconnected.d7fc709f.svg";